import { AfterViewInit, Component, ElementRef, HostListener, EventEmitter, OnChanges, NgZone, Input, OnInit, Output, Renderer2, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ImagePool } from '../device-control/device-screen/image-pool';
import { Router } from '@angular/router';
import { VendorUtilService } from 'src/app/services/vendor-util.service';
import { ScalingService } from 'src/app/services/scaling.service';
import { ControlService } from 'src/app/services/control.service';
import { StorageService } from 'src/app/services/storage.service';
import { LoginService } from 'src/app/services/login.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InstallService } from 'src/app/services/install.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { GroupService } from 'src/app/services/group.service';
import { DeviceColumnService } from 'src/app/services/device-column.service';
import { DeviceService } from 'src/app/services/device.service';
import { AutomationService } from 'src/app/services/automation.service';
import { StandaloneService } from 'src/app/services/standalone.service';
import { StackService } from 'src/app/services/stack-service.service';
import { LogcatService } from 'src/app/services/logcat.service';
import { firstValueFrom, first } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';
import { EncryptionDecryptionService } from 'src/app/services/encryption-decryption.service';
import io, { Socket } from 'socket.io-client';
import * as pako from 'pako';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DraggableComponentComponent } from '../draggable-component/draggable-component.component';




@Component({
  selector: 'app-full-view',
  templateUrl: './full-view.component.html',
  styleUrls: ['./full-view.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, DraggableComponentComponent]
})
export class FullViewComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() device: any;
  @Input() control: ControlService;
  @Output() fullViewExit = new EventEmitter<boolean>();
  @ViewChild('screenshotAlert') alertTemplate: TemplateRef<any>;
  @ViewChild('AppUpload') appInstallTemplate: TemplateRef<any>;
  @ViewChild('logStream') private logStream!: ElementRef;
  private shouldAutoScroll = true;
  appiumLogs: string[] = [];
  appiumStatus: boolean = false;
  control2: any
  private listeners: { [key: string]: EventListener } = {};
  modalRef!: MatDialogRef<any>;
  isNavbar = false;
  showThrottleOptions = false;
  throttleOptions: { label: string, value: number }[] = [
    { label: 'No limit', value: 0 },
    { label: '128kbps', value: 16000 },
    { label: '256kbps', value: 32000 },
    { label: '1mbps', value: 125000 },
    { label: '5mbps', value: 625000 },
    { label: '15mbps', value: 1875000 }
  ];
  aboutDevice: boolean = false;
  aboutDevice2: boolean = false;
  ws: WebSocket;
  wsAppium: Socket;
  element: HTMLElement;
  screen: any;
  cssTransform: any;
  cssTransform2: any;
  canvasAspect: number;
  isScreenRotated: boolean = false;
  loader: boolean = true;
  cursor: string = 'wait';
  displayError: any;
  BLANK_IMG: any;
  URL: any;
  scaler: any;
  prevCoords: { x?: number; y?: number } = {};
  input: HTMLInputElement;
  value: any;
  currentUser: any;
  email: any;
  msg: string;
  appInstalling: boolean = false;
  progress: number = 0;
  i: number = 0;
  screenRecord: boolean = false;
  //for multi-device
  subscription: any;
  unsubscribe: any;
  bridgeHost: any;
  prevCoords2: { x?: number; y?: number } = {};
  scaler2: any;
  input2: HTMLInputElement;
  private listeners2: { [key: string]: EventListener } = {};
  element2: HTMLElement;
  ws2: WebSocket;
  canvasAspect2: number;
  BLANK_IMG2: any;
  displayError2: any;
  screen2: any;
  device2: any;
  list: any;
  items: Element[] = [];
  prefix = 'd' + Math.floor(Math.random() * 1000000) + '-';
  priorityOrder = {
    'Stop Using': 0,
    'Use': 1,
    'Preparing': 2,
    'Ready': 3,
    'Busy': 4,
    'Connected': 5,
    'Unauthorized': 6,
    'Stop Automation': 7,
    'Offline': 8,
    'Disconnected': 9,
    'Unknown': 10
    // 'Unknown': 0,
    // 'Disconnected': 1,
    // 'Offline': 2,
    // 'Stop Automation': 3,
    // 'Unauthorized': 4,
    // 'Connected': 5,
    // 'Busy': 6,
    // 'Ready': 7,
    // 'Preparing': 8,
    // 'Use': 9,
    // 'Stop Using': 10
  };
  activeColumns = [];
  activeFilters = [];
  activeSorting = [];
  columnDefinitions: any;
  selectedDevices: string[] = []; // Array to store selected device serials
  selectedDeviceHTMLRef: HTMLElement[] = []; // Array to store selected device HTML elements
  maxSelections = 3;
  minSelections = 1;
  private clickOutsideListener: () => void;
  mapping = {
    0: {
      0: 0
      , 90: -90
      , 180: -180
      , 270: 90
    }
    , 90: {
      0: 90
      , 90: 0
      , 180: -90
      , 270: 180
    }
    , 180: {
      0: 180
      , 90: 90
      , 180: 0
      , 270: -90
    }
    , 270: {
      0: -90
      , 90: -180
      , 180: 90
      , 270: 0
    }
  }
  tracker: TrackerService;
  selectMultiDevice: boolean = true;

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private vendorUtilService: VendorUtilService,
    private storageService: StorageService,
    private scalingService: ScalingService,
    private renderer: Renderer2,
    private controlService: ControlService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private standaloneService: StandaloneService,
    private stackService: StackService,
    private logcatService: LogcatService,
    private groupService: GroupService,
    private settingsService: SettingsService,
    private deviceColumnService: DeviceColumnService,
    private deviceService: DeviceService,
    private automationService: AutomationService,
    private ngZone: NgZone,
    private installService: InstallService,
    private encryptionDecryptionService: EncryptionDecryptionService,
    private commonService: CommonService
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit(): void {
    window.onbeforeunload = null;
    this.email = this.currentUser.email;
    this.URL = window.URL || window.webkitURL;
    this.BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.cssTransform = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.cssTransform2 = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.isScreenRotated = false;
    this.element = this.elementRef.nativeElement.firstElementChild.children[1];//mobileScreen div
    this.displayError = false;
    this.input = this.element.querySelector('input');

    this.screen = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    this.screen2 = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    this.scaler = this.scalingService.coordinator(
      this.device.display.width
      , this.device.display.height
    );

    //for multi device
    this.BLANK_IMG2 = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.tracker = this.deviceService.trackAll();
    this.columnDefinitions = this.deviceColumnService.columnDefinitions;
    this.list = this.elementRef.nativeElement.querySelector('#deviceList');
    this.items = Array.from(this.list.children) as Element[];

  }

  ngOnChanges(changes: SimpleChanges) {
    // Watch for column updates
    if (changes['columns'] && !changes['columns'].firstChange) {
      const newValue = changes['columns'].currentValue as { name: string, selected: boolean }[];
      this.updateColumns(newValue);
    }

    // Watch for filter updates.
    if (changes['filter']) {

      this.list = this.elementRef.nativeElement.querySelector('ul');
      this.items = Array.from(this.list.children) as Element[];

      const newValue = changes['filter'].currentValue;

      this.updateFilters(newValue);
    }
  }

  ngAfterViewInit(): void {
    this.methodOne();
    this.keyboardHandlingMethod();
    this.touchHandlingMethod();
    //for multi-device
    this.subscription = this.tracker.trackerEventEmitter.subscribe((data: any) => {
      this.list = this.elementRef.nativeElement.querySelector('ul.device-list');
      this.items = Array.from(this.list.children) as Element[];

      if (data.type == "add") {
        this.addListener(data.data);
      }
      if (data.type == "change") {
        this.changeListener(data.data);
      }
      if (data.type == "remove") {
        this.removeListener(data.data);
      }
    });

    //for multi-device
    const element = this.elementRef.nativeElement;
    this.unsubscribe = this.renderer.listen(element, 'click', (event: MouseEvent) => {
      if(this.aboutDevice)this.aboutDevice = false;
      const target = event.target as HTMLElement;
      let id: string;

      if (target.classList.contains('thumbnail')) {
        id = target.id;
      } else if (
        target.classList.contains('device-status') ||
        target.classList.contains('device-photo-small') ||
        target.classList.contains('device-name')
      ) {
        id = ((target.parentNode as HTMLElement).parentNode as HTMLElement).id;
      } else if ((target.parentNode as HTMLElement).classList.contains('device-photo-small')) {
        id = (((target.parentNode as HTMLElement).parentNode as HTMLElement).parentNode as HTMLElement).id;
      }

      if (id) {
        if (!this.selectMultiDevice) {
          const device = this.mapping[id];
          this.device2 = device;

          if (device.using && !device.usable) {
            // Code for using and usable devices
            return
          }

          const currentUser: any = this.currentUser.userObj;


          const groupId = currentUser.groups.subscribed[0];
          //handles the condition where user clicks on an unusable device
          if (!device.usable) {
            this.msg = "Please Select a usable device!";
            this.openAlertMod(this.alertTemplate, this.msg);
            return;
          }
          if (
            !target.classList.contains('btn') ||
            !target.classList.contains('state-using')
          ) {
            if (device.serial != this.device.serial) this.checkGroupValidation(groupId, device.serial);
            else this.openAlertMod(this.alertTemplate, "This Device is taken already");
          }
          if (event.altKey && device.state === 'available') {

            this.inviteDevice(device);
            event.preventDefault();
          }

          if (event.shiftKey && device.state === 'available') {

            this.standaloneService.open(device);
            event.preventDefault();
          }
          // && target.classList.contains('btn') && target.classList.contains('state-using')
          if (device.using && target.classList.contains('btn') && target.classList.contains('state-using')) {


            // 271 sai bhi group vala service call hai aur idhar sainbhi
            this.kickDevice(device);

            event.preventDefault();
            // this.Router.navigate(['devices'])
          }
        } else {
          const device = this.mapping[id];
          if (device.serial != this.device.serial) this.handleDeviceSelection(device, id, target);
        }
      }
    });
  }

  getTopPosition(device: any): string {
    return device?.platform == 'iOS' ? '-3vh' : '-7vh';
  }

  private scrollToBottom(): void {
    try {
      if (this.logStream && this.logStream.nativeElement && this.shouldAutoScroll) {
        const element = this.logStream.nativeElement;
        // Use setTimeout to ensure DOM is updated
        setTimeout(() => {
          element.scrollTop = element.scrollHeight;
        }, 0);
      }
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }

  onScroll(): void {
    const element = this.logStream.nativeElement;
    const threshold = 10; // pixels from bottom
    const position = element.scrollTop + element.offsetHeight;
    const height = element.scrollHeight;

    // If user is near bottom, enable auto-scroll, otherwise disable
    this.shouldAutoScroll = position > height - threshold;
  }

  private handleDeviceSelection(device: any, deviceId: string, target: HTMLElement): void {
    const deviceSerial = device.serial;
    const isCurrentlySelected = this.selectedDevices.includes(deviceSerial);
    const thumbnailElement = this.getThumbnailElement(target);

    if (!device.usable) {
      this.msg = "Please select a usable device!";
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    if (isCurrentlySelected) {
      // Deselect the device
      this.deselectDevice(deviceSerial, thumbnailElement);
    } else {
      // Check if we can select more devices
      if (this.selectedDevices.length >= this.maxSelections) {
        this.msg = `You can select maximum ${this.maxSelections} devices!`;
        this.openAlertMod(this.alertTemplate, this.msg);
        return;
      }

      // Select the device
      this.selectDevice(deviceSerial, thumbnailElement);
    }

    console.log('Selected devices:', this.selectedDevices);
  }

  private selectDevice(deviceSerial: string, thumbnailElement: HTMLElement): void {
    this.selectedDevices.push(deviceSerial);
    this.updateDeviceVisualState(thumbnailElement, true);
  }

  private deselectDevice(deviceSerial: string, thumbnailElement: HTMLElement): void {
    const index = this.selectedDevices.indexOf(deviceSerial);
    if (index > -1) {
      this.selectedDevices.splice(index, 1);
    }
    this.updateDeviceVisualState(thumbnailElement, false);
  }

  private updateDeviceVisualState(thumbnailElement: HTMLElement, isSelected: boolean): void {
    if (isSelected) {
      // Add visual indication for selected device
      thumbnailElement.style.border = '2px solid #007bff';
      thumbnailElement.style.backgroundColor = '#e3f2fd';
      thumbnailElement.classList.add('device-selected');
      this.selectedDeviceHTMLRef.push(thumbnailElement);
    } else {
      // Remove visual indication
      thumbnailElement.style.border = '';
      thumbnailElement.style.backgroundColor = 'white';
      thumbnailElement.classList.remove('device-selected');
    }
  }

  private getThumbnailElement(target: HTMLElement): HTMLElement {
    // Navigate up the DOM to find the thumbnail element
    let current = target;
    while (current && !current.classList.contains('thumbnail')) {
      current = current.parentElement as HTMLElement;
    }
    return current;
  }

  checkGroupValidation(groupId: any, deviceSerial: any) {
    //for multi-device user flow
    this.subscription.unsubscribe();
    this.fullViewExitfunc();
    this.unsubscribe();
    this.commonService.setActiveTab('/control/');
    this.router.navigate(['/control', this.device.serial, 'multi-device', this.device2.serial]);


    //for new backend
    // console.log('renderer still working');

    // this.automationService.validationUsersAsPerGroupMultiDevice(groupId, this.device.serial, deviceSerial).subscribe((res: any) => {
    //   if (res.success === true || res.success === "true") {
    //     this.subscription.unsubscribe();
    //     this.secondDevice = true;
    //     this.getDevice(deviceSerial);
    //     this.deviceService.trackAll();
    //     this.deviceService.trackGroup();
    //     this.unsubscribe();
    //     setTimeout(() => {
    //       this.methodOneDevice2();
    //       this.touchHandlingMethod2();
    //       this.keyboardHandlingMethod2();
    //     }, 2000)
    //   } else {
    //     alert('Maximum Devices use Limit reached\nFor more details Contact to Admin');
    //   }
    // });
  }

  async getDevice(serial: string): Promise<any> {
    try {
      const device: any = await firstValueFrom(this.deviceService.get(serial));
      let stack = this.stackService.getStack();
      if (stack.includes(device.serial)) {
        this.stackService.delete(device.serial);
        this.stackService.push(device.serial);
      } else {
        this.stackService.push(device.serial);
      }
      this.groupService.invite(device);
      this.device2 = device;
      this.device2.using = true;
      this.device2.state = "using";
      this.control2 = this.controlService.create(device, device.channel);


      // TODO: Change title, flickers too much on Chrome
      // $rootScope.pageTitle = device.name
      this.settingsService.set('lastUsedDevice', serial);

      //  $scope.topTabs = [
      //   {
      //     title: gettext('Dashboard'),
      //     icon: 'fa fa-dashboard fa-fw color-pink',
      //     templateUrl: 'control-panes/dashboard/dashboard.pug',
      //     filters: ['native', 'web']

      //   }
      // ].concat(angular.copy(sharedTabs))

      // $scope.belowTabs = [
      //   {
      //     title: gettext('Logs'),
      //     icon: 'fa fa-list-alt color-red',
      //     templateUrl: 'control-panes/logs/logs.pug',
      //     filters: ['native', 'web']
      //   }
      // ]
      return device

    } catch (error) {
      // setTimeout(() => {
      //   // this.router.navigate(['/devices']);
      // });
    }
  }

  inviteDevice(device) {
    // return GroupService.invite(device).then(function () {
    //   scope.$digest()
    // })
  }

  kickDevice(device: any, force?: boolean) {

    this.stackService.delete(device.serial);
    if (Object.keys(this.logcatService.deviceEntries).includes(device.serial)) {
      this.logcatService.deviceEntries[device.serial].allowClean = true;

      this.bridgeHost = device.providerUrl;
      this.automationService.stopAppInspector('', device.serial, this.bridgeHost).subscribe((res: any) => {

        sessionStorage.setItem("appInspectorUrl", null);
      });
    }

    // this.Router.navigate(['/devices']);

    // this.logcatService.allowClean = true;   // dont know what this is
    // $rootScope.LogcatService = this.logcatService; // Not sure what the equivalent would be in Angular

    return this.groupService.kick(device, force).catch((e: any) => {
      this.msg = "Device kicked from the group";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Device kicked from the group');
      throw new Error(e);
    });
  }

  addListener = (device: any) => {

    let item = this.createItem(device);


    this.filterItem(item, device);
    this.insertItem(item, device);
  };

  // Triggers when the tracker notices that a device changed.
  changeListener(device) {

    let id = this.calculateId(device)
    let item = this.list.children[id]


    if (item) {
      // First, update columns
      this.updateItem(item, device)

      // Maybe the item is not sorted correctly anymore?
      let diff = this.compareItem(item, device)


      if (diff !== 0) {
        // Because the item is no longer sorted correctly, we must
        // remove it so that it doesn't confuse the binary search.
        // Then we will simply add it back.
        this.list.removeChild(item)
        this.insertItem(item, device)
      }
    }
  }

  // Triggers when a device is removed entirely from the tracker.
  removeListener(device) {


    let id = this.calculateId(device)
    let item = this.list.children[id]

    if (item) {
      this.list.removeChild(item)
    }
    delete this.mapping[id]
  }

  calculateId(device) {
    return this.prefix + device.serial
  }

  createItem(device: any) {
    let id = this.calculateId(device)
    let item = this.build();

    item.id = id;


    this.update(item, device)
    this.mapping[id] = device

    return item
  }

  build(): HTMLLIElement {


    const li = document.createElement('li');
    // aliceblue
    this.renderer.setStyle(li, 'background-color', 'white');
    this.renderer.setStyle(li, 'width', '10em');
    this.renderer.setStyle(li, 'margin', '0');
    // this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
    this.renderer.setStyle(li, 'border-radius', '8px');
    this.renderer.setStyle(li, 'padding', '5px');
    //for box shadows in device list icons
    this.renderer.listen(li, 'mouseenter', () => {
      // this.renderer.setStyle(li, 'box-shadow', '6px 6px 4px rgba(0, 0, 0, 0.2)');
      this.renderer.setStyle(li, 'box-shadow', '0 6px 12px rgba(0, 0, 0, 0.2)');
      this.renderer.setStyle(li, 'transform', 'translateY(-2px)');
      this.renderer.setStyle(li, 'transition', 'transform 0.2s ease, box-shadow 0.2s ease');

    });
    this.renderer.listen(li, 'mouseleave', () => {
      this.renderer.removeStyle(li, 'transform');
      // this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
      this.renderer.removeStyle(li, 'box-shadow');
    });
    this.renderer.listen(li, 'mousedown', () => {
      this.renderer.setStyle(li, "transform", "translateY(4px)");
      // this.renderer.setStyle(li, "transform", "translateX(4px)");
    });
    this.renderer.listen(li, 'mouseup', () => {
      this.renderer.removeStyle(li, 'transform');
    });
    li.className = 'cursor-select pointer thumbnail';
    // the whole li is a link
    const a = document.createElement('a');
    li.appendChild(a);

    // .device-photo-small
    const photo = document.createElement('div');
    photo.className = 'device-photo-small';
    const img = document.createElement('img');
    photo.appendChild(img);
    a.appendChild(photo);

    // .device-name
    const name = document.createElement('div');
    name.className = 'device-name';
    this.renderer.setStyle(name, 'color', 'unset')
    name.appendChild(document.createTextNode(''));
    a.appendChild(name);

    // button
    const button = document.createElement('button');
    this.renderer.setStyle(button, 'white-space', 'nowrap')
    button.appendChild(document.createTextNode(''));
    a.appendChild(button);
    //new
    // li.appendChild(button);

    return li;
  }

  filterItem(item, device) {
    if (this.match(device)) {
      item.classList.remove('filter-out')
      if (item.className === 'cursor-select pointer thumbnail' || item.className === 'cursor-select pointer thumbnail device-is-busy') {
        item.style.display = ''

      }
    }
    else {
      item.classList.add('filter-out')
      if (item.className === 'cursor-select pointer thumbnail device-is-busy filter-out' || item.className === 'cursor-select pointer thumbnail filter-out') {
        item.style.display = 'none';
      }
      else {
        item.style.display = ''
      }
    }
  }

  // Compares an item to its siblings to see if it's still in the correct
  // position. Returns <0 if the device should actually go somewhere
  // before the previous item, >0 if it should go somewhere after the next
  // item, or 0 if the position is already correct.
  compareItem(item, device) {
    let prev = item.previousSibling
    let next = item.nextSibling
    let diff

    if (prev) {
      diff = this.compare(device, this.mapping[prev.id])
      if (diff < 0) {
        return diff
      }
    }

    if (next) {
      diff = this.compare(device, this.mapping[next.id])
      if (diff > 0) {
        return diff
      }
    }

    return 0
  }

  //updated compare function
  compare(deviceA: any, deviceB: any) {
    // const mapping = {
    //   asc: 1,
    //   desc: -1
    // };

    let diff: number;

    // First check the priority based on enhancedStateAction
    const textA = deviceA.enhancedStateAction;
    const textB = deviceB.enhancedStateAction;

    // Default to highest possible priority number
    let priorityA = Object.keys(this.priorityOrder).length;
    let priorityB = Object.keys(this.priorityOrder).length;

    // Find matching priorities
    for (const [key, value] of Object.entries(this.priorityOrder)) {
      if (textA.includes(key)) priorityA = value;
      if (textB.includes(key)) priorityB = value;
    }

    // If priorities are different, return their difference
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // If priorities are equal, continue with other sorting criteria
    // for (let i = 0, l = this.activeSorting.length; i < l; ++i) {
    //   const sort = this.activeSorting[i];
    //   diff = this.columnDefinitions[sort.name].compare(deviceA, deviceB);
    //   if (diff !== 0) {
    //     diff *= mapping[sort.order];
    //     break;
    //   }
    // }

    return diff;
  }

  // Updates visible columns. This method doesn't necessarily have to be
  // the fastest because it shouldn't get called all the time.
  updateColumns(columnSettings) {
    let newActiveColumns = []

    // Check what we're supposed to show now
    columnSettings.forEach(function (column) {
      if (column.selected) {
        newActiveColumns.push(column.name)
      }
    })

    // Figure out the patch
    let patch = this.patchArray(this.activeColumns, newActiveColumns)

    // Set up new active columns
    this.activeColumns = newActiveColumns

    return this.patchAll(patch)
  }


  // Updates all the columns in the item. Note that the item must be in
  // the right format already (built with createItem() and patched with
  // patchItem() if necessary).
  updateItem(item, device) {
    let id = this.calculateId(device)
    // if(device.present==true && device.usable)
    // {

    //   device.enhancedStateAction='Use'
    // }
    item.id = id
    this.update(item, device)

    return item
  }

  update(li: any, device: any) {
    let a = li.firstChild
    let img = a.firstChild.firstChild
    let name = a.firstChild.nextSibling
    let nt = name.firstChild
    let button = name.nextSibling

    if (device.enhancedStateAction == "Stop Using") {
      console.log(this.currentUser.userObj.privilege, "this.currentUser");
      if (device.owner?.name !== "admin") {
        if (this.currentUser.userObj.privilege == "admin") {
          this.renderer.setStyle(button, 'background-color', '#ff6426');
          this.renderer.setStyle(button, 'color', 'Black');
        } else {
          this.renderer.setStyle(button, 'background-color', '#167ffc');
          this.renderer.setStyle(button, 'color', 'white');
        }
      } else {
        this.renderer.setStyle(button, 'background-color', '#167ffc');
        this.renderer.setStyle(button, 'color', 'white');
      }
    }
    else if (device.enhancedStateAction == "Preparing") {
      this.renderer.setStyle(button, 'color', 'rgb(255 255 255)');
      this.renderer.setStyle(button, 'background-color', 'rgb(41 121 1)');
      this.renderer.setStyle(button, 'border-radius', '80px')
    }
    else {
      this.renderer.setStyle(button, 'background-color', '#eaeaea');
      this.renderer.setStyle(button, 'color', '#555');
    }
    let at = button.firstChild

    let classes = 'btn btn-xs device-status '


    // .device-photo-small
    if (img.getAttribute('src') !== device.enhancedImage120 || device.ios) {
      img.setAttribute('src', device.enhancedImage120)
    }

    // .device-name
    nt.nodeValue = device.enhancedName;

    // button
    at.nodeValue = device.enhancedStateAction;

    let getStateClasses = (state) => {
      let stateClasses = {
        using: 'state-using btn-primary',
        busy: 'state-busy btn-warning',
        available: 'state-available btn-outline-primary',
        ready: 'state-ready btn-outline-primary',
        present: 'state-present btn-outline-primary',
        preparing: 'state-preparing btn-outline-primary btn-outline-success',
        unauthorized: 'state-unauthorized btn-outline-danger',
        offline: 'state-offline btn btn-light',
        automation: 'state-automation btn btn-light'
      }[state]
      if (typeof stateClasses === 'undefined') {
        stateClasses = 'btn btn-light'
      }
      return stateClasses
    }


    //stop-using button click  idar sai bhi call hota hai
    if (getStateClasses(device.state) === 'state-using btn-primary') {
      button.addEventListener('click', () => {
        this.groupService.kick(device);

        // this.Router.navigate(['devices']);
      });

    }


    button.className = classes + getStateClasses(device.state);

    if (device.state === 'available') {
      name.classList.add('state-available')
    } else {
      name.classList.remove('state-available')
    }

    if (device.usable && !device.using) {
      //a.href = '#!/control/' + device.serial
      // a.href = '';
      li.classList.remove('device-is-busy')
    }
    else if (device.using && device.usable) {
      // a.href = '#!/control/' + device.serial
      //a.href = '';

    }
    else {
      a.removeAttribute('href')
      li.classList.add('device-is-busy')
    }
    return li
  }

  // Updates filters on visible items.
  updateFilters(filters) {
    this.activeFilters = filters;
    return this.filterAll();
  }

  // Applies filteItem() to all items.
  filterAll() {


    for (let i = 0, l = this.items.length; i < l; ++i) {
      this.filterItem(this.items[i], this.mapping[this.items[i].id])
    }

  }

  // Checks whether the device matches the currently active filters.
  match(device) {

    if (device.serial === this.device.serial) {
      return null;
    }

    for (let i = 0, l = this.activeFilters.length; i < l; ++i) {
      let filter = this.activeFilters[i]
      let column
      if (filter.field) {
        column = this.columnDefinitions[filter.field]
        if (column && !column.filter(device, filter)) {
          return false
        }
      }
      else {
        let found = false
        for (let j = 0, k = this.activeColumns.length; j < k; ++j) {
          column = this.columnDefinitions[this.activeColumns[j]]
          if (column && column.filter(device, filter)) {
            found = true
            break
          }
        }
        if (!found) {
          return false
        }
      }
    }
    return true
  }

  // Inserts an item into the table into its correct position according to
  // current sorting.
  insertItem(item, deviceA) {
    return this.insertItemToSegment(item, deviceA, 0, this.items.length - 1)
  }

  // Inserts an item into a segment of the table into its correct position
  // according to current sorting. The value of `hi` is the index
  // of the last item in the segment, or -1 if none. The value of `lo`
  // is the index of the first item in the segment, or 0 if none.
  insertItemToSegment(item, deviceA, low, high) {
    let total = this.items.length
    let lo = low
    let hi = high

    if (lo > hi) {
      // This means that `lo` refers to the first item of the next
      // segment (which may or may not exist), and we should put the
      // row before it.
      this.list.insertBefore(item, lo < total ? this.items[lo] : null)
    }
    else {
      let after = true
      let pivot = 0
      let deviceB

      while (lo <= hi) {
        pivot = ~~((lo + hi) / 2)
        deviceB = this.mapping[this.items[pivot].id];

        let diff = this.compare(deviceA, deviceB)

        if (diff === 0) {
          after = true
          break
        }

        if (diff < 0) {
          hi = pivot - 1
          after = false
        }
        else {
          lo = pivot + 1
          after = true
        }
      }

      if (after) {
        this.list.insertBefore(item, this.items[pivot].nextSibling)
      }
      else {
        this.list.insertBefore(item, this.items[pivot])
      }
    }
  }

  patchArray(a, b) {
    let ops = []

    let workA = [].concat(a)
    let inA = Object.create(null)
    let itemA, cursorA, itemB, cursorB

    let inB = this.existenceMap(b)
    let posB = Object.create(null)

    // First, check what was removed from a.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]

      // If b does not contain the item, surely it must have been removed.
      if (!inB[itemA]) {
        workA.splice(cursorA, 1)
        ops.push(['remove', cursorA])
      }
      // Otherwise, the item is still alive.
      else {
        inA[itemA] = true
        cursorA += 1
      }
    }

    // Then, check what was inserted into b.
    for (cursorB = 0; cursorB < b.length; ++cursorB) {
      itemB = b[cursorB]

      // If a does not contain the item, it must have been added.
      if (!inA[itemB]) {
        workA.splice(cursorB, 0, itemB)
        ops.push(['insert', cursorB, itemB])
      }

      posB[itemB] = cursorB
    }

    // At this point, workA contains the same items as b, but swaps may
    // be needed.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]
      let posInB = posB[itemA]

      if (posInB === cursorA) {
        cursorA += 1
      }
      else {
        let temp = workA[posInB]
        workA[posInB] = itemA
        workA[cursorA] = temp
        ops.push(['swap', cursorA, posInB])
      }
    }
    return ops
  }

  // Patches all items.
  patchAll(patch) {
    for (let i = 0, l = this.items.length; i < l; ++i) {
      this.patchItem(this.items[i], this.mapping[this.items[i].id], patch)
    }
  }

  // Patches the given item by running the given patch operations in
  // order. The operations must take into account index changes caused
  // by previous operations.
  patchItem(item, device, patch) {
    // Currently no-op
  }

  existenceMap(array) {
    let map = Object.create(null)
    for (let i = 0, l = array.length; i < l; ++i) {
      map[array[i]] = 1
    }
    return map
  }

  navbarToggle() {
    this.isNavbar = !this.isNavbar;
  }

  openScreenRecord() {
    this.screenRecord = !this.screenRecord;
  }

  cross() {
    this.screenRecord = !this.screenRecord;
  }

  aboutDeviceToggle() {
    this.aboutDevice = !this.aboutDevice
  }

  aboutDeviceToggle2() {
    this.aboutDevice2 = !this.aboutDevice2
  }

  fullViewExitfunc() {
    this.ws = null;
    this.input?.removeEventListener('keydown', this.listeners['keydown']);
    this.input?.removeEventListener('keyup', this.listeners['keyup']);
    this.input?.removeEventListener('input', this.listeners['input']);
    this.input?.removeEventListener('paste', this.listeners['paste']);
    this.input?.removeEventListener('copy', this.listeners['copy']);
    //for device 2 if there
    this.ws2 = null;
    this.input2?.removeEventListener('keydown', this.listeners2['keydown']);
    this.input2?.removeEventListener('keyup', this.listeners2['keyup']);
    this.input2?.removeEventListener('input', this.listeners2['input']);
    this.input2?.removeEventListener('paste', this.listeners2['paste']);
    this.input2?.removeEventListener('copy', this.listeners2['copy']);
    this.fullViewExit.emit(false);
  }

  key(key: any) {
    if (this.device.ios) {
      this.control.keyPress(key)
      return
    }
    this.control.keyDown(key)
    this.control.keyUp(key)
  }

  key2(key: any) {
    if (this.device2.ios) {
      this.control2.keyPress(key)
      return
    }
    this.control2.keyDown(key)
    this.control2.keyUp(key)
  }

  press(key) {
    this.control.keyPress(key)
  }

  openSettings() {
    if (this.device.ios)
      this.control.openSetting();
    else
      this.run('am start -a android.intent.action.MAIN -n com.android.settings/.Settings')
  }

  run(cmd) {
    let command = cmd;
    // Force run activity
    command += ' --activity-clear-top'
    // return this.control.shell(command).then(function(result) {
    //     // console.log(result)
    //   })
    return this.control.shell(command);
  }

  openSettings2() {
    this.run2('am start -a android.intent.action.MAIN -n com.android.settings/.Settings')
  }

  run2(cmd) {
    let command = cmd;
    // Force run activity
    command += ' --activity-clear-top'
    // return this.control.shell(command).then(function(result) {
    //     // console.log(result)
    //   })
    return this.control2.shell(command);
  }

  appInstall() {
    this.modalRef = this.dialog.open(this.appInstallTemplate, { width: '300px' });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0] as File;
    this.installFile(file, this.device.serial);
  }

  installFile(file, deviceSerial: any) {
    if (file.type === 'application/vnd.android.package-archive') {
      // Process the file upload

      // this.uploadApk =false;
      this.appInstalling = true
      const interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 10;
        } else {
          clearInterval(interval); // Stop when it reaches 100%  
        }
      }, 900);
      return this.installService.installFile(this.control, file, deviceSerial);

    } else {
      this.msg = "Please select a valid APK file.";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please select a valid APK file.');
      return null;
    }
  }

  takeScreenShot() {
    if (this.device.ios) {
      this.control.screenshotIos().then((result) => {


        this.control2.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    else {
      this.control2.screenshot().then((result) => {


        this.control2.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    this.openAlertMod(this.alertTemplate, 'Screenshot taken! You can view the screenshots in the Screenshot tab');
  }

  takeScreenShot2() {

    // let blob = new Blob([], {
    //   type: 'image/jpeg'
    // })
    // let url = URL.createObjectURL(blob)
    // // img.src
    // let mySrc = this.sanitizer.bypassSecurityTrustUrl(url);
    // this.source=url
    if (this.device2.ios) {
      this.control2.screenshotIos().then((result) => {


        this.control2.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    else {
      this.control2.screenshot().then((result) => {


        this.control2.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    this.openAlertMod(this.alertTemplate, 'Screenshot taken! You can view the screenshots in the Screenshot tab');
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      // setTimeout(() => {
      //   this.msg = "";
      // }, 2000)
      // this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
  }

  resizeImageOfIos(param) {
    if (this.value < param.min) {
      this.value = param.min;
    } else if (this.value > param.max) {
      this.value = param.max;
    }

    let cols = document.getElementsByClassName('screenshot-image resizeIOS') as HTMLCollectionOf<HTMLImageElement>;
    for (let i = 0; i < cols.length; i++) {
      let sampleWidth = 550 * ((this.value / 100) * param.step);
      let sampleHeight = 1000 * ((this.value / 100) * param.step);
      cols[i].style.width = (225 + sampleWidth) + 'px';
      cols[i].style.height = (400 + sampleHeight) + 'px';
    }
  }

  methodOne() {
    let _global = this;

    // ios change
    if (this.device.ios) {
      this.ws = new WebSocket(this.device.url);
    }
    else {
      this.ws = new WebSocket(this.device.display.url);
    }
    // ios change
    this.ws.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    let canvas = this.element.querySelector('canvas');
    // let canvas = this.element.find('canvas')[0]
    //let mobile_wrapper=element.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element.querySelector('div');

    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }


    this.ws.onerror = function errorListener() {
      // @todo Handle
    }

    this.ws.onclose = function closeListener() {
      // @todo Maybe handle
      _global.ws = null;
    }

    this.ws.onopen = function openListener() {
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      let w = _global.screen.bounds.w = (_global.element.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen.bounds.h = (_global.element.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device anymore.
        _global.device.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws.send('on')
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('off')
      }
    }

    if (this.ws) {
      const existingHandler = (() => {

        let cachedScreen = {
          rotation: 0,
          bounds: { x: 0, y: 0, w: 0, h: 0 }
        };

        let cachedImageWidth = 0;
        let cachedImageHeight = 0;
        let cssRotation = 0;
        let alwaysUpright = false;
        let imagePool = new ImagePool(10);

        function applyQuirks(banner: any) {
          _global.element.classList.toggle(
            'quirk-always-upright',
            alwaysUpright = banner.quirks.alwaysUpright
          );
        }

        function hasImageAreaChanged(img: any) {
          return cachedScreen.bounds.w !== _global.screen.bounds.w ||
            cachedScreen.bounds.h !== _global.screen.bounds.h ||
            cachedImageWidth !== img.width ||
            cachedImageHeight !== img.height ||
            cachedScreen.rotation !== _global.screen.rotation;
        }

        function isRotated() {
          return _global.screen.rotation === 90 || _global.screen.rotation === 270;
        }

        function updateImageArea(img: any) {
          if (!hasImageAreaChanged(img)) return;

          cachedImageWidth = img.width;
          cachedImageHeight = img.height;

          if (options.autoScaleForRetina) {
            canvas.width = cachedImageWidth * frontBackRatio;
            canvas.height = cachedImageHeight * frontBackRatio;
            g.scale(frontBackRatio, frontBackRatio);
          } else {
            canvas.width = cachedImageWidth;
            canvas.height = cachedImageHeight;
          }

          cssRotation += _global.rotator(cachedScreen.rotation, _global.screen.rotation);
          if (_global.screen.rotation == 90)
            canvas.style[_global.cssTransform] = 'rotate(' + -90 + 'deg)'
          else if (_global.screen.rotation == 270)
            canvas.style[_global.cssTransform] = 'rotate(' + 270 + 'deg)'
          else
            canvas.style[_global.cssTransform] = 'rotate(0deg)'

          cachedScreen.bounds.h = _global.screen.bounds.h;
          cachedScreen.bounds.w = _global.screen.bounds.w;
          cachedScreen.rotation = _global.screen.rotation;

          // let canvasAspect = canvas.width / canvas.height;
          const incwidth = canvas.width * 1.035;
          const incheight = canvas.height * 1.025;
          _global.canvasAspect = incwidth / incheight;

          // if (isRotated()) {
          //   _global.isScreenRotated = true;
          //   // canvasAspect = img.height / img.width;
          //   _global.element.classList.add('rotated');
          //   _global.element.parentElement.firstElementChild.classList.add('rotatedImg');
          // } else {
          //   _global.isScreenRotated = false;
          //   // canvasAspect = img.width / img.height;
          //   _global.element.classList.remove('rotated');
          //   _global.element.parentElement.firstElementChild.classList.remove('rotatedImg');
          // }

          // if (alwaysUpright) {
          //   positioner.style[_global.cssTransform] = 'rotate(' + -cssRotation + 'deg)';
          // }

          if (isRotated()) {
            _global.isScreenRotated = true;
            let incHeight = canvas.height * 1.12; //increase the height of the wrapper by 6%
            let decWidth = canvas.width * 1.061; //decrease the width of the wrapper by 6%
            _global.canvasAspect = decWidth / incHeight;
            // store portrait dims so CSS can swap them for landscape
            // positionerEl.style.setProperty('--positioner-w', positionerEl.offsetWidth + 'px');
            // positionerEl.style.setProperty('--positioner-h', positionerEl.offsetHeight + 'px');
          } else {
            _global.isScreenRotated = false;
            // positionerEl.style.removeProperty('--positioner-w');
            // positionerEl.style.removeProperty('--positioner-h');
          }

          maybeFlipLetterbox();
        }

        return function messageListener(message: any) {
          _global.screen.rotation = _global.device.display.rotation;

          // if (message.data instanceof Blob) {
          //   _global.loader = false;
          //   _global.cursor = 'default';

          //   if (shouldUpdateScreen()) {
          //     if (_global.displayError) {
          //       // scope.$apply(() => this.displayError = false);
          //     }

          //     let blob = new Blob([message.data], { type: 'image/jpeg' });
          //     let img = imagePool.next();
          //     let url = URL.createObjectURL(blob);

          //     img.onload = () => {
          //       updateImageArea(img);
          //       g.drawImage(img, 0, 0, img.width, img.height);

          //       img.onload = img.onerror = null;
          //       img.src = _global.BLANK_IMG;
          //       img = null;
          //       blob = null;

          //       URL.revokeObjectURL(url);
          //       url = null;
          //     };

          //     img.onerror = () => {
          //       img.onload = img.onerror = null;
          //       img.src = _global.BLANK_IMG;
          //       img = null;
          //       blob = null;

          //       URL.revokeObjectURL(url);
          //       url = null;
          //     };

          //     img.src = url;
          //   }
          // } 
          //new decompression for screen blobs in FE
          if (message.data instanceof Blob) {
            _global.loader = false;
            _global.cursor = 'default';
            const reader = new FileReader();

            reader.onload = () => {
              const compressed = new Uint8Array(reader.result as ArrayBuffer);
              const decompressed = pako.ungzip(compressed);

              const blob = new Blob([decompressed], { type: 'image/jpeg' });

              const img = imagePool.next();
              img.onload = () => {
                updateImageArea(img);
                g.drawImage(img, 0, 0, img.width, img.height);
                // Cleanup...
              };
              img.onerror = () => {
                // Handle error and cleanup...
              };
              const url = URL.createObjectURL(blob);
              img.src = url;
            };

            reader.readAsArrayBuffer(message.data);
          }
          else if (/^start /.test(message.data)) {
            applyQuirks(JSON.parse(message.data.substr('start '.length)));
          } else if (message.data === 'secure_on') {
            // scope.$apply(() => scope.displayError = 'secure');
          }
        };
      })();

      const originalOnMessage = existingHandler;

      this.ws.onmessage = (event: MessageEvent) => {
        // Call the original message handler
        if (typeof originalOnMessage === 'function') {
          originalOnMessage.call(this.ws, event);
        }

        // Extra handler for throttle_response
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'throttle_response') {
            if (!data.success && data.message.includes('Android version')) {
              this.ngZone.run(() => {
                this.msg = data.message;
                this.openAlertMod(this.alertTemplate, this.msg);
              });
            }
          }
        } catch (e) {
          // Ignore non-JSON or invalid JSON
        }
      };
    }


    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element.offsetWidth / _global.element.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element;

    //   if (this.isScreenRotated) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  toggleThrottleOptions(): void {
    setTimeout(() => {
      this.showThrottleOptions = !this.showThrottleOptions;
    }, 0);
  }

  applyThrottle(option: { label: string, value: number }): void {
    // Check if we have device information
    if (!this.device && !this.device.ios) {
      this.msg = 'No device information available';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    // Check Android version first
    const androidVersion = parseFloat(this.device.version || '0');

    if (!androidVersion || androidVersion < 13) {
      this.msg = 'Throttling is not supported on this device. Android 13 or higher is required.';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    // Create payload including version
    // const payload = {
    let command = `settings put global ingress_rate_limit_bytes_per_second ${option.value}`;
    command = command.toString();
    // androidVersion: this.device.version
    // };

    // Send command to WebSocket server
    //new logic
    this.control.shell(command);
    this.msg = `Throttle set to ${option.label}`;
    this.openAlertMod(this.alertTemplate, this.msg);
    this.toggleThrottleOptions();
  }


  rotator(oldRotation: any, newRotation: any) {
    let r1 = oldRotation < 0 ? 360 + oldRotation % 360 : oldRotation % 360
    let r2 = newRotation < 0 ? 360 + newRotation % 360 : newRotation % 360

    return this.mapping[r1][r2];
  }

  touchHandlingMethod() {

  // helper for iOS landscape transform
  let transformCoordsForIosLandscape = (xP: number, yP: number) => {
    if (this.device.ios !== true || !this.isScreenRotated) {
      return { xP, yP };
    }
    return { xP: yP, yP: 1 - xP };
  }

  let slots = [];
  let slotted = Object.create(null);
  let fingers = [];
  let seq = -1;
  let cycle = 100;
  let fakePinch = false;
  let lastPossiblyBuggyMouseUpEvent: any = 0;

  let nextSeq = () => ++seq >= cycle ? (seq = 0) : seq;

  let createSlots = () => {
    for (let i = 9; i >= 0; --i) {
      let finger = createFinger(i);
      this.element.append(finger);
      slots.push(i);
      fingers.unshift(finger);
    }
  }

  let activateFinger = (index: any, x: any, y: any, pressure: any) => {
    let scale = 0.5 + pressure
    fingers[index].classList.add('active')
    fingers[index].style[this.cssTransform2] =
      'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ',' + scale + ')'
  }

  let deactivateFinger = (index: any) => fingers[index].classList.remove('active')

  let deactivateFingers = () => fingers.forEach(f => f.classList.remove('active'))

  let createFinger = (index: any) => {
    let el = document.createElement('span')
    el.className = 'finger finger-' + index
    return el;
  }

  let calculateBounds = () => {
    let el = this.element as HTMLElement;
    this.screen.bounds.w = el.offsetWidth
    this.screen.bounds.h = el.offsetHeight
    this.screen.bounds.x = 0
    this.screen.bounds.y = 0

    while (el.offsetParent) {
      this.screen.bounds.x += el.offsetLeft
      this.screen.bounds.y += el.offsetTop
      el = el.offsetParent as HTMLElement;
    }
  }

  let mouseDownListener = (event: any) => {
    let e = event.originalEvent || event;
    if (e.which === 3) return;
    e.preventDefault()

    fakePinch = e.altKey
    calculateBounds()
    startMousing()

    let x = e.pageX - this.screen.bounds.x;
    let y = e.pageY - this.screen.bounds.y;
    let pressure = 0.5

    let scaled = this.scaler.coords(
      this.screen.bounds.w,
      this.screen.bounds.h,
      x, y,
      this.screen.rotation
    )

    let transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP)

    this.prevCoords = { x: transformedCoords.xP, y: transformedCoords.yP }

    if (this.device.ios) {
      this.control.touchDownIos(nextSeq(), 0, transformedCoords.xP, transformedCoords.yP, pressure)
      if (fakePinch) {
        this.control.touchDownIos(nextSeq(), 1, 1 - transformedCoords.xP, 1 - transformedCoords.yP, pressure)
      }
    } else {
      this.control.touchDown(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
      if (fakePinch) {
        this.control.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
      }
    }

    this.control.touchCommit(nextSeq())
    activateFinger(0, x, y, pressure)

    this.element.addEventListener('mousemove', mouseMoveListener);
    this.element.addEventListener('mouseup', mouseUpListener);
    this.element.addEventListener('mouseleave', mouseUpListener);
  }

  let mouseMoveListener = (event: any) => {
    let e = event.originalEvent || event;
    if (e.which === 3) return;
    e.preventDefault()

    let x = e.pageX - this.screen.bounds.x
    let y = e.pageY - this.screen.bounds.y
    let pressure = 0.5

    let scaled = this.scaler.coords(
      this.screen.bounds.w,
      this.screen.bounds.h,
      x, y,
      this.screen.rotation
    )

    let transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP)

    if (this.device.ios) {
      this.control.touchMoveIos(
        transformedCoords.xP,
        transformedCoords.yP,
        this.prevCoords.x,
        this.prevCoords.y,
        pressure,
        nextSeq(),
        0
      )
    } else {
      this.control.touchMove(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
    }

    this.prevCoords = { x: transformedCoords.xP, y: transformedCoords.yP }

    this.control.touchCommit(nextSeq())
    activateFinger(0, x, y, pressure)
  }

  let mouseUpListener = (event: any) => {
    let e = event.originalEvent || event;
    if (e.which === 3) return;
    e.preventDefault()

    let x = e.pageX - this.screen.bounds.x
    let y = e.pageY - this.screen.bounds.y
    let pressure = 0.5

    let scaled = this.scaler.coords(
      this.screen.bounds.w,
      this.screen.bounds.h,
      x, y,
      this.screen.rotation
    )

    let transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP)

    if (this.device.ios) {
      this.control.touchMoveIos(
        transformedCoords.xP,
        transformedCoords.yP,
        this.prevCoords.x,
        this.prevCoords.y,
        pressure,
        nextSeq(),
        0
      )
    }

    this.control.touchUp(nextSeq(), 0)
    this.control.touchCommit(nextSeq())
    deactivateFinger(0)
    stopMousing()
  }

  let mouseUpBugWorkaroundListener = (e: any) => {
    lastPossiblyBuggyMouseUpEvent = e
  }

  let startMousing = () => {
    this.control.gestureStart(nextSeq())
    this.input.focus()
  }

  let stopMousing = () => {
    this.element.removeEventListener('mousemove', mouseMoveListener);
    this.element.removeEventListener('mouseup', mouseUpListener);
    this.element.removeEventListener('mouseleave', mouseUpListener);
    deactivateFingers()
    this.control.gestureStop(nextSeq())
  }

  let touchStartListener = (event: any) => {
    let e = event.originalEvent || event;
    e.preventDefault()
    calculateBounds()

    if (e.touches.length === e.changedTouches.length) {
      startTouching()
    }

    for (let touch of e.changedTouches) {
      let slot = slots.pop()
      let x = touch.pageX - this.screen.bounds.x
      let y = touch.pageY - this.screen.bounds.y
      let pressure = touch.force || 0.5

      let scaled = this.scaler.coords(
        this.screen.bounds.w,
        this.screen.bounds.h,
        x, y,
        this.screen.rotation
      )

      let transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP)

      if (this.device.ios) {
        this.control.touchDownIos(nextSeq(), slot, transformedCoords.xP, transformedCoords.yP, pressure)
      } else {
        this.control.touchDown(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
      }

      slotted[touch.identifier] = slot
      activateFinger(slot, x, y, pressure)
    }

    this.control.touchCommit(nextSeq())
  }

  let touchMoveListener = (event: any) => {
    let e = event.originalEvent || event;
    e.preventDefault()

    for (let touch of e.changedTouches) {
      let slot = slotted[touch.identifier]
      let x = touch.pageX - this.screen.bounds.x
      let y = touch.pageY - this.screen.bounds.y
      let pressure = touch.force || 0.5

      let scaled = this.scaler.coords(
        this.screen.bounds.w,
        this.screen.bounds.h,
        x, y,
        this.screen.rotation
      )

      let transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP)

      if (this.device.ios) {
        this.control.touchMoveIos(
          transformedCoords.xP,
          transformedCoords.yP,
          this.prevCoords?.x || transformedCoords.xP,
          this.prevCoords?.y || transformedCoords.yP,
          pressure,
          nextSeq(),
          slot
        )
      } else {
        this.control.touchMove(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
      }

      this.prevCoords = { x: transformedCoords.xP, y: transformedCoords.yP }

      activateFinger(slot, x, y, pressure)
    }

    this.control.touchCommit(nextSeq())
  }

  let touchEndListener = (event: any) => {
    let e = event.originalEvent || event;

    for (let touch of e.changedTouches) {
      let slot = slotted[touch.identifier]
      if (slot === undefined) continue;

      delete slotted[touch.identifier]
      slots.push(slot)
      this.control.touchUp(nextSeq(), slot)
      deactivateFinger(slot)
    }

    this.control.touchCommit(nextSeq())
  }

  let startTouching = () => this.control.gestureStart(nextSeq())

  let stopTouching = () => {
    deactivateFingers()
    this.control.gestureStop(nextSeq())
  }

  this.renderer.listen(this.element, 'touchstart', touchStartListener);
  this.renderer.listen(this.element, 'mousedown', mouseDownListener);
  this.renderer.listen(this.element, 'mouseup', mouseUpBugWorkaroundListener);

  createSlots()
}

  keyboardHandlingMethod() {
    let isChangeCharsetKey = (e: any) => {
      // Add any special key here for changing charset

      // Chrome/Safari/Opera
      if (
        // Mac | Kinesis keyboard | Karabiner | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0010' ||

        // Mac | MacBook Pro keyboard | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0020' ||

        // Win | Lenovo X230 keyboard | Alt+Latin key
        e.keyCode === 246 && e.keyIdentifier === 'U+00F6' ||

        // Win | Lenovo X230 keyboard | Convert key
        e.keyCode === 28 && e.keyIdentifier === 'U+001C'
      ) {
        return true
      }

      // Firefox
      switch (e.key) {
        case 'Convert': // Windows | Convert key
        case 'Alphanumeric': // Mac | Latin key
        case 'RomanCharacters': // Windows/Mac | Latin key
        case 'KanjiMode': // Windows/Mac | Kana key
          return true
      }

      return false
    }

    let handleSpecialKeys = (e: any) => {
      if (isChangeCharsetKey(e)) {
        e.preventDefault();
        this.control.keyPress('switch_charset');
        return true;
      }
      return false;
    }

    this.listeners['keydownListener'] = (e: any) => {
      // Prevent tab from switching focus to the next element2, we only want
      // that to happen on the device2 side.

      if (e.code == "ArrowLeft") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_left" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_left" })
      }
      if (e.code == "ArrowRight") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_right" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_right" })
      }
      if (e.code == "ArrowUp") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_up" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_up" })
      }
      if (e.code == "ArrowDown") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_down" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_down" })
      }
      if (e.code == "Enter") {
        this.control.sendEnter('input.keyDown', { 'key': "enter" })
        this.control.sendEnter('input.keyUp', { 'key': "enter" })
      }
      if (e.code == "Backspace") {
        this.control.sendBackspace('input.keyDown', { 'key': "del" });
        this.control.sendBackspace('input.keyUp', { 'key': "del" });
      }
      if (e.code == "Delete") {
        this.control.sendDelete('input.keyDown', { 'key': "forward_del" });
        this.control.sendDelete('input.keyUp', { 'key': "forward_del" });
      }
      if (e.keyCode === 9) {
        e.preventDefault();
      }
      this.control.keyDown(e.keyCode)
    }

    this.listeners['keyupListener'] = (e: any) => {
      if (!handleSpecialKeys(e)) {
        this.control.keyUp(e.keyCode);
      }
    }

    this.listeners['pasteListener'] = (e: any) => {
      // Prevent value change or the input event sees it. This way we get
      // the real value instead of any "\n" -> " " conversions we might see
      // in the input value.
      e.preventDefault();
      this.control.paste(e.clipboardData.getData('text/plain'))
    }

    this.listeners['copyListener'] = (e: any) => {
      e.preventDefault()
      // This is asynchronous and by the time it returns we will no longer
      // have access to setData(). In other words it doesn't work. Currently
      // what happens is that on the first copy, it will attempt to fetch
      // the clipboard contents. Only on the second copy will it actually
      // copy that to the clipboard.
      this.control.getClipboardContent();
      if (this.control.clipboardContent) {
        e.clipboardData.setData('text/plain', this.control.clipboardContent);
      }
    }

    this.listeners['inputListener'] = (e: any) => {
      // Why use the input event if we don't let it handle pasting? The
      // reason is that on latest Safari (Version 8.0 (10600.1.25)), if
      // you use the "Romaji" Kotoeri input method, we'll never get any
      // keypress events. It also causes us to lose the very first keypress
      // on the page. Currently I'm not sure if we can fix that one.
      //check this <-----------------------------------------------------
      this.control.sendKeyInput('input.type', e)


      // this.control.type(this.value);
      // this.value = ''
    }
    this.input.addEventListener('keydown', this.listeners['keydownListener']);
    this.input.addEventListener('keyup', this.listeners['keyupListener']);
    this.input.addEventListener('input', this.listeners['inputListener']);
    this.input.addEventListener('paste', this.listeners['pasteListener']);
    this.input.addEventListener('copy', this.listeners['copyListener']);

    // this.input.bind('keydown', keydownListener);
    // this.input.bind('keyup', keyupListener);
    // this.input.bind('input', inputListener);
    // this.input.bind('paste', pasteListener);
    // this.input.bind('copy', copyListener);
  }


  getAppiumLogs() {
    this.appiumStatus = !this.appiumStatus;
    if (this.appiumStatus) {
      // Connect to the Socket.IO server
      let clippedUrl: string = this.device?.providerUrl.replace(/\/wd\/hub$/, '')
      let provider = clippedUrl.split('.com/')[1]?.split('/')[0]; //e.g, provider1
      let baseUrl = window.location.origin;
      console.log('Connecting to Appium logs at(this.baseUrl):', baseUrl, 'Provider:', provider);

      this.wsAppium = io(baseUrl, {
        path: '/' + provider + '/socket.io',
        reconnection: false,
        transports: ['websocket'],
        withCredentials: true
      });
      // Data to send
      let data: any = { "serial": this.device.serial };

      // Socket.IO connection handling
      this.wsAppium.on('connect', () => {
        // Emit events using Socket.IO syntax
        this.wsAppium.emit("get_logs", data);
      });

      // Listen for incoming messages
      this.wsAppium.on('logs', (data: any) => {
        this.appiumLogs.push(data.log);
        // Handle the received logs here
        this.scrollToBottom();
      });

      // Handle connection errors
      this.wsAppium.on('connect_error', (error) => {
        console.error('Connection error:', error);
      });
    } else {
      this.wsAppium.disconnect();
      this.appiumLogs = [];
    }
  }

  getLogClass(index: number): string {
    if (this.appiumLogs[index].includes('ERROR')) return 'error-log';
    if (this.appiumLogs[index].includes('WARNING')) return 'warning-log';
    return `default-log`;
  }

  launchMutliDevice() {
    console.log('Launching multi device for encrypted string:',
      this.encryptionDecryptionService.encryptDeviceSerials(this.selectedDevices),
      '\n Selected devices:', this.encryptionDecryptionService.decryptDeviceSerials('0008YgQW'));
    this.commonService.setActiveTab('/control/');
    this.router.navigate(['/control', this.device.serial, 'multi-device', this.encryptionDecryptionService.encryptDeviceSerials(this.selectedDevices)]);
  }
}

